var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "container"
  }, [_vm._m(0), _c("div", {
    staticClass: "img-wrap1"
  }), _c("div", {
    staticClass: "user",
    on: {
      click: function click($event) {
        return _vm.toAccount(_vm.userInfo);
      }
    }
  }, [_vm.userInfo.avatarUrl ? _c("img", {
    staticClass: "img",
    attrs: {
      src: _vm.userInfo.avatarUrl,
      alt: ""
    }
  }) : _c("img", {
    staticClass: "img",
    attrs: {
      src: require("../../assets/images/icon_avatar.png"),
      alt: ""
    }
  }), _c("div", {
    staticClass: "txt-con"
  }, [_c("span", {
    staticClass: "nickname"
  }, [_vm._v(_vm._s(_vm.userInfo.nickname))]), _c("span", {
    staticClass: "des"
  }, [_vm._v(_vm._s(_vm.userInfo.signature))])])]), _c("div", {
    staticClass: "select"
  }, [_c("div", {
    staticClass: "select-item",
    on: {
      click: function click($event) {
        return _vm.toDetail("Works", _vm.toUserId);
      }
    }
  }, [_c("span", {
    staticClass: "num"
  }, [_vm._v(_vm._s(_vm.userInfo.threadCount))]), _c("span", {
    staticClass: "des"
  }, [_vm._v("Works")])]), _c("div", {
    staticClass: "select-item",
    on: {
      click: function click($event) {
        return _vm.toDetail("Favorites", _vm.toUserId);
      }
    }
  }, [_c("span", {
    staticClass: "num"
  }, [_vm._v(_vm._s(_vm.userInfo.collectionCount))]), _c("span", {
    staticClass: "des"
  }, [_vm._v("Favorites")])]), _c("div", {
    staticClass: "select-item",
    on: {
      click: function click($event) {
        return _vm.toDetail("Follow", _vm.toUserId);
      }
    }
  }, [_c("span", {
    staticClass: "num"
  }, [_vm._v(_vm._s(_vm.userInfo.followCount))]), _c("span", {
    staticClass: "des"
  }, [_vm._v(_vm._s(_vm.$t("Follow")))])]), _c("div", {
    staticClass: "select-item",
    on: {
      click: function click($event) {
        return _vm.toDetail("Fans", _vm.toUserId);
      }
    }
  }, [_c("span", {
    staticClass: "num"
  }, [_vm._v(_vm._s(_vm.userInfo.fansCount))]), _c("span", {
    staticClass: "des"
  }, [_vm._v("Fans")])])])]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "bg"
  }, [_c("img", {
    attrs: {
      src: require("../../assets/images/Banner1.png"),
      alt: ""
    }
  })]);
}];
render._withStripped = true;
export { render, staticRenderFns };